import React from 'react';
import { convertValueToUSD } from '../../../../../../../../helpers/currency.helper';

interface IAmountRendererProps {
  amount: number;
  isOverDue: boolean;
}
export const AmountRenderer = ({ amount, isOverDue }: IAmountRendererProps) => (<span data-testid='BillsHub__table-column-amount' className={`${isOverDue ? 'text-red02' : ''}`}>{convertValueToUSD(amount, 2)}</span>);
